import React from 'react'
import { useForm } from 'react-hook-form'
import './Advertise.css'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


export default function App() {
    const { register, handleSubmit, watch, errors } = useForm()
    const onSubmit = data => {  }

    console.log(watch('business')) // watch input value by passing the name of it

    return (
        <div style={{ display: 'flex', flex: 1, verticalAlign: 'text-top', maxHeight: '1064px', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'center', maxWidth: '50%' }} >
                <div style={{ position: 'fixed', width: '50%' }}>
                    <div style={{ position: 'relative', maxWidth: '100%', margin: '13% 0% 0% 0%', textAlign: 'center' }} >
                        <strong style={{ fontSize: 100, alignSelf: 'center', textAlign: 'center', color: 'rgb(29, 185, 84)', maxWidth: '100%' }}>Ad Options</strong>
                        <h3>In-app display ads for $70 per month</h3>
                        <h3>Push notifications for $0.25 per user</h3>
                        <p style={{ padding: '10%' }}>We offer the cheapest most effective way to advertise to students with advertising options that meet students in the flow of their everyday lives. Push notifications while they're checking their phones. In app display ads while they're buying party tickets.</p>
                        <a href={`mailto:business.xsell@gmail.com?&subject=Advertising%20Inquiry&body=`} rel="EMAIL">Email us</a>
                        {/* <form action='mailto:business.xsell@gmail.com'>
                            
                            <input name="business" placeholder="Business name" ref={register({ required: true })} style={{ margin: '2vh', border: 'none', borderBottom: '2px solid black'}} />

                            
                            <input name="email" placeholder="Email" ref={register({ required: true })} style={{ margin: '2vh', border: 'none', borderBottom: '2px solid black'}}/>
                            <br></br>

                            <label><input type="checkbox" name="display" ref={register}/> Display</label><br></br>
                            <label><input type="checkbox" name="push" ref={register}/> Push notifications</label><br></br>
                            {errors.exampleRequired && <span>This field is required</span>}

                            <input className="button" type="submit"></input>
                        </form> */}
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'center', width: '50%', }} >
                {/* <img style={{height: '50%', maxWidth: '30%', position: "absolute", top: '10%', left: "40%", boxShadow: "4px 4px 2px grey"}} src={require('../../assets/ad_allDeals.JPG')} />
        <img style={{height: '50%', maxWidth: '30%', position: "relative", top: '0%', left: "20%"}} src={require('../../assets/Screenshot_20200405-175454_XSell_Restart.jpg')} />
        <img style={{height: '8%', maxWidth: '30%', position: "relative", top: '17.5%', left: "17%"}} src={require('../../assets/ad_notification.PNG')} /> */}
                <div style={{ display: 'flex', flexDirection: 'row', flex: 1, justifyContent: 'center', alignItems: 'center', }} >
                    <img style={{ height: '65vh', width: '35vh', padding: '10px', borderRadius: '20px', marginRight: '5vh' }} src={require('../../assets/ad_allDeals.JPG')} />
                    <img style={{ height: '65vh', width: '35vh', padding: '10px', borderRadius: '20px', marginLeft: '5vh' }} src={require('../../assets/Screenshot_20200405-175454_XSell_Restart.jpg')} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', flex: 1, justifyContent: 'center', alignItems: 'center', }} >
                    <img style={{ margin: '5%', height: '15vh', width: '50vh', borderRadius: '10px' }} src={require('../../assets/ad_notification.PNG')} />
                </div>
            </div>
        </div>

    )
}

